import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import useLeadDocuments from "../../../data/useLeadDocuments";
import { DocumentType, IDocument } from "../../../models/Document";
import { ILead } from "../../../models/Lead";
import Card from "../../shared/Card/Card";
import ImageCarousel from "../../shared/Images/ImageCarousel";
import LoadingWheel from "../../shared/LoadingWheel";

export default function LeadIdentityImages({ lead }: { lead: ILead }) {
  const { t } = useTranslation("leads");
  const { leadDocuments, downloadDoc } = useLeadDocuments(lead.id, "LeadIdentityImages");

  const [isLoading, setIsLoading] = useState(true);
  const [images, setImages] = useState<IDocument[]>([]);

  useEffect(() => {
    if (!leadDocuments.isLoading && leadDocuments.data) {
      let displayImages: IDocument[] = [];

      //Get identity images
      displayImages.push(...leadDocuments.data?.data?.filter((doc: IDocument) => doc.type === DocumentType["Identity"])! || []);

      setImages(displayImages);
      setIsLoading(false);
    }

  }, [leadDocuments.data, leadDocuments.isLoading])

  if (isLoading) {
    return (
      <Card title={t("Identity Images")} bodyClassName="p-4">
        <LoadingWheel />
      </Card>
    )
  }

  return (
    <>
      <Card title={t("Identity Images")} bodyClassName="p-4" collapsible>
        <ImageCarousel images={images} leadId={lead.id} size="w-44 h-44" />
      </Card>
    </>
  )
}